import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IPrePublishRequestPayload {
    id: string
    data: {
        publishAll?: boolean
        companies?: string[]
    }
}

export interface ICreateState {
    status: string
    data: null
    errors: any
}

const initialState: ICreateState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const prePublishListSlice = createSlice({
    name: 'hub/editList/pre-publish',
    initialState,
    reducers: {
        onRequest(state, actions: PayloadAction<IPrePublishRequestPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const prePublishListActions = prePublishListSlice.actions
export default prePublishListSlice.reducer
